import {
  CurrencyEnum,
  TransactionProxyState,
  TransactionProxyStatus,
} from "@lib/types";
import * as yup from "yup";

export const transactionSchema = yup.object().shape({
  id: yup.string().required().uuid(),
  amount: yup.number().required(),
  currency: yup.string().required().oneOf(Object.values(CurrencyEnum)),
  customerId: yup.string().required().uuid(),
  providerId: yup.string().required().uuid(),
  status: yup.string().required().oneOf(Object.values(TransactionProxyStatus)),
  state: yup.string().required().oneOf(Object.values(TransactionProxyState)),
  providerTransactionConfigId: yup.string().nullable().uuid(),
});
